module.exports = __webpack_public_path__ + "static/sustainable-lodging-2-f16d672fb013c44c088c778696d68b74.png";